import { Modal, Button } from "rsuite";
import React, { useState, useEffect, useRef } from "react";
import "./SessionExpiredModal.css";

export const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

const SessionExpiredModal = ({ open, onHide, hasTabsWithQueries, setSessionExpired, sessionExpired }) => {
  const warningTimeout = 300; // 5 minutes in seconds
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState(warningTimeout); // 5 minutes in seconds
  const [title, setTitle] = useState("");
  const [showModal, setShowModal] = useState(false);

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!open) return;
  
    if (hasTabsWithQueries && timer == warningTimeout) {
      setTitle(`Session will expire in ${formatTime(timer)} mins`);
      setMessage(`Please save your unsaved queries If not it will be lost.`);
      setShowModal(true);
  
      intervalRef.current = setInterval(() => {
        setTimer((prev) => {
          const newTime = prev - 1;
          if (newTime > 0) {
            setTitle(`Session will expire in ${formatTime(newTime)} mins`);
            setMessage(`Please save your unsaved queries If not it will be lost.`);
          } else {
            clearInterval(intervalRef.current);
            setTitle("Session Expired");
            setMessage("Your session has expired. Please log in again.");
          }
          return Math.max(newTime, 0);
        });
      }, 1000);
    }
  
    timeoutRef.current = setTimeout(() => {
      setSessionExpired(true);
      setTitle("Session Expired");
      setMessage("Your session has expired. Please log in again.");
      setShowModal(true);
      setTimer(0);
    }, 300000);
  
    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, [open, hasTabsWithQueries]);

  const handleOkay = () => {
    setShowModal(false);
    clearInterval(intervalRef.current);
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setSessionExpired(true);
      setTitle("Session Expired");
      setMessage("Your session has expired. Please log in again.");
      setShowModal(true);
      setTimer(0);
    }, timer * 1000);
  };

  const handleLoginRedirect = () => {
    window.location.href = "/login";
  };

  return (
    <Modal
      open={open && showModal}
      onHide={onHide}
      backdrop="static"
      className="session-modal"
      size="xs"
    >
      <Modal.Body>
        <div className="session-content">
          <h6 className="session-title">{title}</h6>
          <p className={`session-message ${sessionExpired ? "default-message" : "warning-message"}`}>{message}</p>
        </div>
      </Modal.Body>

      <Modal.Footer className="session-footer">
        {!sessionExpired && hasTabsWithQueries && timer > 0 ? (
          <Button onClick={handleOkay} appearance="primary" className="session-button">
            Back to Query Editor
          </Button>
        ) : (
          <Button onClick={handleLoginRedirect} appearance="primary" className="session-button">
            Go to Login
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredModal;
